import styles from "../styles/features.module.css";
import { featuresData } from "../data/featuresData";

const Features = () => {
  return (
    <section id="features" className={styles.featuresSection}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.sectionTitle}>
          Everything You Need for an Automated Job Search
        </h2>
        {/* <p className={styles.sectionSubtitle}>
          Leverage powerful automation and AI while keeping your job search
          completely private and secure on your own computer.
        </p> */}
        <div className={styles.featureGrid}>
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className={styles.featureCard}
              style={{
                "--watermark-icon": `'${feature.iconUnicode}'`,
                "--icon-color": feature.iconColor,
              }}
            >
              <div
                className={styles.featureIconWrapper}
                style={{ backgroundColor: feature.bgColor }}
              >
                <i
                  className={feature.icon}
                  style={{ color: feature.iconColor }}
                ></i>
              </div>
              <div className={styles.featureContent}>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
